import { render, staticRenderFns } from "./FooterExtended.vue?vue&type=template&id=27d9c468"
import script from "./FooterExtended.vue?vue&type=script&lang=js"
export * from "./FooterExtended.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports